<!--
  ~ Copyright (C) 2018 - present by OpenGamma Inc. and the OpenGamma group of companies
  ~
  ~ Please see distribution for license.
  -->

<og-labeled-entity [label]="label" [subtext]="subtext" [size]="size" [theme]="theme">
  <span content>{{ text }}</span>
</og-labeled-entity>
